import { useStripeReportApi } from "../api/StripeReportApiClient";
import { StripeReportFrontendService } from "../services/StripeReportFrontendService";

export const useStripeReportService = (): StripeReportFrontendService =>
  new StripeReportFrontendService(useStripeReportApi());
